import "./Post.css";
import {
  Col,
  Row,
  FormControl,
  Button,
  Form,
  Container,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";

import Uploadpost from "../Modals/Upload_post/uploadpost";
import {
  generalFriendsList,
  timelinemodal,
} from "../../../../constants/jsonConstant";
import { getAsset } from "../../../../helpers/helper";

// Import Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { usePostState } from "../../../../hooks/usePostState";
import dummyUser from "../../../../assets/images/dummy/dummy-user.png";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../../utils/idObfuscator";
import { useState, useEffect } from "react";

const ProfileAvatar = ({ profile, dummyUser }) => {
  const [imgSrc, setImgSrc] = useState(dummyUser);

  useEffect(() => {
    let source =
      (typeof profile?.image === "string" && profile.image) ||
      (typeof profile?.imageUrl === "string" && profile.imageUrl) ||
      profile?.images?.[0] ||
      (Array.isArray(profile?.image) ? profile?.image[0] : null) ||
      (Array.isArray(profile?.imageUrl) ? profile?.imageUrl[0] : null);

    // Check if the source is an invalid string
    if (
      source === "null" ||
      source === "undefined" ||
      source === "N/A" ||
      String(source || "").trim() === ""
    ) {
      source = null;
    }

    if (source) {
      const img = new Image();
      img.src = getAsset(source);

      img.onload = () => {
        setImgSrc(img.src);
      };

      img.onerror = () => {
        setImgSrc(dummyUser);
      };
    } else {
      setImgSrc(dummyUser);
    }
  }, [profile, dummyUser]);

  return <img src={imgSrc} alt="" />;
};

const Post = ({
  mysetting,
  data,
  CreatePostSubmit,
  setCreatePost,
  createPost,
  show,
  setShow,
  id,
  mybusinessType,
}) => {
  const {
    searchTerm,
    setSearchTerm,
    displayData,
    loading,
    isSending,
    isAccepting,
    handleSearch,
    handleClear,
    ConnectShop,
    getConnectionStatus,
    handleAccept,
    handleClose,
    handleOpenModal,
  } = usePostState({ data, id, mybusinessType, setShow, mysetting });

  const navigate = useNavigate();

  const businessTypeRoutes = {
    homemadeShop: "/Home-Made-Item-Userprofile/",
    gemShop: "/Minerl-And-Mining-UserProfile/",
    services: "/services-online/",
    usedShop: "/usedItems-userprofile/",
    rawmaterialShop: "/rawmaterial-userprofile/",
    manufacturerShop: "/manufacturer-userprofile/",
    wholesellerShop: "/wholeseller-userprofile/",
    retailerShop: "/retailer-userprofile/",
    recycledShop: "/Recycleuserprofile/",
    farmingShop: "/Farminguserprofile/",
    usedVehicleShop: "/Byvehicleuserprofile/",
    transportShop: "/buying-transport/",
    businessPropertyCompany: "/user-peronal-property/",
    foodShop: "/food-buying-profile/",
    company: "/find-jobs-online/",
    jobsCompany: "/find-jobs-online/",
    generalPublic: "/other-profile/",
    marketerProfile: "/view-marketer-profile/",
    "Approved Marketers": "/view-marketer-profile/",
  };

  const handleProfileClick = (profile) => {
    const route =
      businessTypeRoutes[profile?.businessType] || "/other-profile/";
    const rawId =
      profile?.shopid?._id ||
      profile?.shopid ||
      profile?.userid?._id ||
      profile?.userid ||
      profile?._id;
    const finalId =
      profile?.businessType === "marketerProfile" ||
      profile?.businessType === "Approved Marketers"
        ? rawId && rawId !== "null"
          ? encodeId(rawId)
          : encodeId(profile._id)
        : rawId && rawId !== "null"
          ? rawId
          : profile._id;
    navigate(`${route}${finalId}`);
  };

  return (
    <>
      {/* {show === 2 && <Livemodal show={show} handleClose={handleClose} />} */}
      {show === true && (
        <Uploadpost
          show={show}
          handleClose={handleClose}
          CreatePostSubmit={CreatePostSubmit}
          setCreatePost={setCreatePost}
          createPost={createPost}
        />
      )}

      <Container>
        <Row>
          <Col lg="12" md="12">
            {/* SEARCH BAR - ICON VISIBLE & CLICKABLE */}

            {data && data.length > 0 ? (
              <Form
                onSubmit={handleSearch}
                className="d-flex align-items-center"
              >
                <div
                  className="search-container position-relative flex-grow-1"
                  style={{ maxWidth: "100%" }}
                >
                  <FormControl
                    type="text"
                    placeholder="Search"
                    className="mr-sm-2 mt-2 w-100 pr-5"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ position: "relative", zIndex: 1 }}
                  />

                  {/* SEARCH ICON - FIXED & VISIBLE */}
                  <Button
                    type="submit"
                    variant="link"
                    className="p-1 mt-1 position-absolute d-flex align-items-center justify-content-center"
                    style={{
                      right: "0px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                      width: "10%",
                      backgroundColor: "#0353a4",
                    }}
                  >
                    <SearchIcon
                      className="text-white mt-1"
                      style={{ fontSize: "20px" }}
                    />
                  </Button>
                </div>

                {/* CLEAR BUTTON */}
                {searchTerm && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="ms-2 mt-2"
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                )}
              </Form>
            ) : (
              ""
            )}

            {/* DATA GRID */}

            {loading ? (
              <Row
                className="mt-3 rounded bg-white pb-2 pt-xl-3 pt-lg-1 pt-md-3 pt-sm-3 pt-xs-3 display-setting scroll-container"
                style={{
                  boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                  margin: "1px",
                }}
              >
                {[...Array(6)].map((_, index) => (
                  <Col
                    lg="2"
                    md="2"
                    sm="2"
                    xs="2"
                    className="ps-2 pe-2"
                    key={index}
                  >
                    <div className="personImgSize">
                      <Skeleton height="100%" />
                    </div>
                    <p className="font_11 mt-3 mb-0 text-center">
                      <Skeleton width={60} />
                    </p>
                    <button type="button" className="folow-btn mt-0" disabled>
                      <Skeleton height={28} width={70} />
                    </button>
                  </Col>
                ))}
              </Row>
            ) : displayData && displayData.length > 0 ? (
              <Row
                className="mt-3 rounded bg-white pb-2 pt-xl-3 pt-lg-1 pt-md-3 pt-sm-3 pt-xs-3 display-setting scroll-container"
                style={{
                  boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                  margin: "1px",
                }}
              >
                {displayData.map((profile) => (
                  <Col
                    lg="2"
                    md="2"
                    sm="2"
                    xs="2"
                    className="ps-2 pe-2"
                    key={profile?._id}
                  >
                    <div
                      className="personImgSize"
                      onClick={() => handleProfileClick(profile)}
                      style={{ cursor: "pointer" }}
                    >
                      <ProfileAvatar profile={profile} dummyUser={dummyUser} />
                    </div>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-${profile?._id}`}>
                          {profile?.shopname ||
                            profile?.profileName ||
                            profile?.companyname ||
                            profile?.fullname}
                        </Tooltip>
                      }
                    >
                      <p
                        className="font_11 mt-3 mb-0 text-center"
                        onClick={() => handleProfileClick(profile)}
                        style={{ cursor: "pointer" }}
                      >
                        {(
                          profile?.shopname ||
                          profile?.profileName ||
                          profile?.companyname ||
                          profile?.fullname
                        )?.length > 8
                          ? (
                              profile?.shopname ||
                              profile?.profileName ||
                              profile?.companyname ||
                              profile?.fullname
                            ).slice(0, 7) + "..."
                          : profile?.shopname ||
                            profile?.profileName ||
                            profile?.companyname ||
                            profile?.fullname}
                      </p>
                    </OverlayTrigger>
                    {getConnectionStatus(profile) === "connected" ? (
                      <button
                        type="button"
                        className="folow-btn mt-0"
                        style={{
                          backgroundColor: "#198754",
                          color: "#fff",
                          cursor: "default",
                          opacity: 0.9,
                        }}
                        disabled
                      >
                        ✓ Connected
                      </button>
                    ) : getConnectionStatus(profile) === "loading" ? (
                      <button
                        type="button"
                        className="folow-btn mt-0"
                        style={{
                          backgroundColor: "#6c757d",
                          color: "#fff",
                          cursor: "not-allowed",
                        }}
                        disabled
                      >
                        Loading...
                      </button>
                    ) : getConnectionStatus(profile) === "pending" ? (
                      <button
                        type="button"
                        className="folow-btn mt-0"
                        style={{
                          backgroundColor: "#e0a800",
                          color: "#fff",
                          cursor: "not-allowed",
                          opacity: 0.85,
                        }}
                        disabled
                      >
                        Pending
                      </button>
                    ) : getConnectionStatus(profile) === "accept" ? (
                      <button
                        type="button"
                        className="folow-btn mt-0"
                        style={{
                          backgroundColor: "#0d6efd",
                          color: "#fff",
                        }}
                        disabled={isAccepting}
                        onClick={() => handleAccept(profile)}
                      >
                        {isAccepting ? "Accepting..." : "Accept"}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="folow-btn mt-0"
                        disabled={isSending}
                        onClick={() => ConnectShop(profile)}
                      >
                        Connect
                      </button>
                    )}
                  </Col>
                ))}
              </Row>
            ) : Array.isArray(data) ? (
              mysetting !== "home" &&
              mysetting !== "marketerProfile" &&
              mysetting !== "Approved Marketers" ? (
                <Row
                  className="mt-3 rounded bg-white pb-2 pt-xl-3 pt-lg-1 pt-md-3 pt-sm-3 pt-xs-3 display-setting"
                  style={{
                    boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                    margin: "1px",
                  }}
                >
                  <Col lg="12" className="text-center p-4">
                    <h6 className="text-muted">
                      {data.length > 0
                        ? "No Result found"
                        : mysetting === "generalPublic"
                          ? "No general public profiles found."
                          : "No shops available to connect yet."}
                    </h6>
                  </Col>
                </Row>
              ) : null
            ) : mysetting !== "home" &&
              mysetting !== "marketerProfile" &&
              mysetting !== "Approved Marketers" ? (
              <Row
                className="mt-3 rounded bg-white pb-2 pt-xl-3 pt-lg-1 pt-md-3 pt-sm-3 pt-xs-3 display-setting"
                style={{
                  boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                  margin: "1px",
                }}
              >
                <Col lg="12" className="text-center p-4">
                  <h6 className="text-muted">
                    No shops available to connect yet.
                  </h6>
                </Col>
              </Row>
            ) : null}
          </Col>
        </Row>
      </Container>

      {/* Timeline Buttons */}
      {mysetting?.length === 4 ? (
        <Container>
          <Row>
            <Col
              lg="12"
              md="10"
              sm="11"
              xs="11"
              className="d-flex text-center bg-white p-3 mt-3"
              style={{
                boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                margin: "1px",
              }}
            >
              {timelinemodal?.map((item) => (
                <div style={{ width: "33%" }} className="p-0" key={item.id}>
                  <button
                    className="btn font_small p-0 m-0"
                    key={item.id}
                    onClick={() => handleOpenModal(item.id)}
                  >
                    <span style={{ color: item.color }}>{item.icon}</span>{" "}
                    {item.text}
                  </button>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      ) : (
        ""
      )}
    </>
  );
};

export default Post;
